/**
 * D10: Teacher Notes
 */

import { isBackendEnabled, readJson, writeJson } from '../helpers';

// Per domein — dit domein heeft nog geen backend. Zie helpers.ts.
const USE_BACKEND = isBackendEnabled('teacherNotes');
const TEACHER_NOTES_KEY = 'teacher_notes';

/** Get the note for a specific student, or empty string if none exists */
export async function getTeacherNote(studentId: string): Promise<string> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  const allNotes = readJson<Record<string, string>>(TEACHER_NOTES_KEY, {});
  return allNotes[studentId] || '';
}

/** Save a note for a specific student */
export async function saveTeacherNote(studentId: string, note: string): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  const allNotes = readJson<Record<string, string>>(TEACHER_NOTES_KEY, {});
  allNotes[studentId] = note;
  writeJson(TEACHER_NOTES_KEY, allNotes);
}